import "core-js/modules/es.number.constructor";
import { defineComponent, computed, watch } from '@vue/composition-api';
export default defineComponent({
  props: {
    total: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 0
    },
    transitionStart: {
      type: Boolean,
      default: true
    },
    delay: {
      type: Number,
      default: 100
    }
  },
  setup: function setup(props, ctx) {
    var percent = computed(function () {
      var current = props.current,
          total = props.total;
      return current ? (current / total * 100).toFixed(2) : 0;
    });
    watch(function () {
      return percent.value;
    }, function (val) {
      if (val && props.transitionStart) {
        setTimeout(function () {
          ctx.refs.bar.style.width = "".concat(val, "%");
        }, props.delay);
      }
    }, {
      immediate: true
    });
    watch(function () {
      return props.transitionStart;
    }, function (val) {
      if (val) {
        ctx.refs.bar.style.width = "".concat(percent.value, "%");
      }
    });
    return {
      percent: percent
    };
  }
});